import React, { Component } from 'react';
import NurBlock from 'components/NurBlock/NurBlock';
import Hero from 'components/Hero/Hero';
import Questions from 'components/Questions/Questions';
import LayoutWrapper from 'src/layouts/LayoutWrapper'

class HomePage extends Component {
    render() {
        const {
            data
        } = this.props

        const thisPageData = data.contentfulHomePage

        return (
            <LayoutWrapper>
                <div>
                    <Hero
                        backgroundImage={thisPageData.heroBackgroundImage.file.url}
                        title={thisPageData.heroTitle}
                        copy={thisPageData.heroCopy.heroCopy}
                        searchPlaceholder={thisPageData.heroSearchPlaceholder}
                        searchButtonLabel={thisPageData.heroSearchButtonLabel}
                    />
                    <Questions
                        backgroundImage={thisPageData.questionsBackgroundImage.file.url}
                        questions={thisPageData.questions}
                    />
                    <NurBlock
                        titleIllustration={thisPageData.nurTitleIllustration.file.url}
                        characterIllustration={thisPageData.nurCharacterIllustration.file.url}
                        copy={thisPageData.nurCopy.nurCopy} nurPdf={thisPageData.nurPdf.file.url}
                        buttonLabel={thisPageData.nurButtonLabel}
                    />
                </div>
            </LayoutWrapper>
        )

    }
};

export default HomePage;

export const homePageQuery = graphql`
  query homePageQuery($id: String!) {
    siteSearchIndex {
      index
    }
    contentfulHomePage(id: { eq: $id }) {
      __typename
      ... on ContentfulHomePage {
        heroTitle
        heroSearchPlaceholder
        heroSearchButtonLabel
        heroCopy {
          heroCopy
        }
        heroBackgroundImage {
          file {
            url
          }
        }
        questionsBackgroundImage {
          file {
            url
          }
        }
        questions {
          question
          answer {
            json
          }
        }
        nurTitleIllustration {
          file {
            url
          }
        }
        nurCharacterIllustration {
          file {
            url
          }
        }
        nurCopy {
          nurCopy
        }
        nurButtonLabel
        nurPdf {
          file {
            url
          }
        }
      }
    }
  }
`;